// engine
import { ArController, soundService, SPIN_MODE, userDispatcher } from '@aceroll/core';

// platform
import { platform } from '../../platform';

// services
import { autoplayService } from '../../services/autoplay-service';

export class GameStart extends ArController {
	onStart() {
		this.context.setLayout('Game');

		platform.setGameStarted();

		// subscribe to global platform ivents
		platform.onAutoplayStart((data) => {
			autoplayService.start(data);
		});
		platform.onAutoplayEnd(() => {
			autoplayService.stop();
		});

		// soundService subscriptions
		platform.onSoundOn(() => {
			soundService.mute(false);
		});
		platform.onSoundOff(() => {
			// global mute including music and sfx
			soundService.mute(true);
		});
		platform.onMusicOn(() => {
			soundService.muteMusic(false);
		});
		platform.onMusicOff(() => {
			soundService.muteMusic(true);
		});

		// SlotMachine subscriptions
		platform.onTurboOn((data) => {
			console.log('TURBO ON', data);
			userDispatcher.setState({
				baseGameSpinMode: SPIN_MODE.TURBO,
				bonusGameSpinMode: SPIN_MODE.TURBO
			});
		});
		platform.onTurboOff((data) => {
			console.log('TURBO OFF', data);

			userDispatcher.setState({
				baseGameSpinMode: SPIN_MODE.DEFAULT,
				bonusGameSpinMode: SPIN_MODE.DEFAULT
			});
		});
		platform.onSuperTurboOn((data) => {
			console.log('TURBO super ON', data);

			userDispatcher.setState({
				baseGameSpinMode: SPIN_MODE.SUPER_TURBO,
				bonusGameSpinMode: SPIN_MODE.SUPER_TURBO
			});
		});
		platform.onSuperTurboOff((data) => {
			console.log('TURBO super OFF', data);

			userDispatcher.setState({
				baseGameSpinMode: SPIN_MODE.DEFAULT,
				bonusGameSpinMode: SPIN_MODE.DEFAULT
			});
		});
		this.stop();
	}
}
